import { getEntityRef } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { setShowingDetailId } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector } from "./selectors";
import { type MemberRecurringOrders } from "./types";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      items: localState.items,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onItemClick: (item: MemberRecurringOrders.Item) =>
    dispatch(setShowingDetailId({ ...getEntityRef(props), itemId: item.id }))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
